import React from 'react'
import SellerLookupView from './SellerLookupView'
import * as sellerService from '../SellerService'
import * as FlashMessage from '../../FlashMessage/FlashMessageConstants'

export default class SellerLookup extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            sellerId: null,
            seller: null,
            loading: null,
            disableSearch: false,
            invalidInput: false
        }
        this.handleInput = this.handleInput.bind(this)
        this.handleKeydown = this.handleKeydown.bind(this)
    }

    componentDidMount() {
        this.props.setPath(this.props.match.path)
    }

    render() {
        return <SellerLookupView 
            handleInput={this.handleInput}
            handleKeydown={this.handleKeydown}
            seller={this.state.seller}
            loading={this.state.loading}
            disableSearch={this.state.disableSearch}
            renderCardDefinition={this.renderCardDefinition}
            invalidInput={this.state.invalidInput}
            />
    }

    handleInput(event) {
        this.setState({
            sellerId: event.detail.value
        })
    }

    handleKeydown(event) {
        const ENTER_KEYCODE = 13
        if (event.detail.keyCode === ENTER_KEYCODE) {
            if (this.isValidSellerId(this.state.sellerId)) {
                this.setState({invalidInput: false})
                this.getSeller(this.state.sellerId)
            } else {
                this.setState({invalidInput: true})
            }
        }
    }

    isValidSellerId(sellerId) {
        const VALID_AWS_ACCOUNT_ID_REGEX = /^[0-9]{12}$/
        return sellerId && VALID_AWS_ACCOUNT_ID_REGEX.test(sellerId)
    }

    getSeller(sellerId) {
        this.setState({
            seller : null,
            loading: true,
            disableSearch: true
        })
        const { setFlashMessage, dismissFlashMessage } = this.props
        dismissFlashMessage()
        return sellerService.getSeller(sellerId)
            .then(seller => {
                this.setState({seller: JSON.parse(seller)})
            })
            .catch(() => {
                setFlashMessage(FlashMessage.SellerLookupFailed)
            })
            .finally(() => {
                this.setState({
                    loading: false,
                    disableSearch: false
                })
            })
    }

    renderCardDefinition = (items, header) => {
        let sections = []
        if (typeof items === 'string') {
            sections.push({
                id: items,
                content: this.camelCaseToSentenceCase(items)
            })
        } else {
            Object.keys(items).forEach((key,index) => {
                sections.push({
                    id: key,
                    header: this.camelCaseToSentenceCase(key),
                    content: this.formatCardContent(items[key])
                })
            });
        }
        return {
            header: this.camelCaseToSentenceCase(header),
            sections
        }
    }

    formatCardContent(content) {
        if (Array.isArray(content)) {
            return content.map((value, index) => {
                return <p key={index}>{value}</p>
            })
        } else if (typeof content === 'object') {
            const flattened = this.flatten(content)
            return Object.keys(flattened).map((key,index) =>
                    <p key={index}>{this.camelCaseToSentenceCase(key)}: {this.formatString(flattened[key])}</p>
                )
        }
        return this.formatString(content)
    }

    formatString(item) {
        if (this.isURL(item)) {
            return <a href={item} target="_blank">{item}</a>
        }
        return item !== null ? item.toString() : 'N/A'
    }

    camelCaseToSentenceCase(camel) {
        return camel
            .replace(/([A-Z])/g, ' $1')
            // uppercase the first letter
            .replace(
                /^./, 
                function(str){
                    return str.toUpperCase()
                }
            )
    }

    // flattens an object: { a: {b : 'c'}} => {'a - b':'c'}
    flatten(data) {
        var result = {}
        function recurse (cur, prop) {
            if (Object(cur) !== cur) {
                result[prop] = cur
            } else if (Array.isArray(cur)) {
                 for(var i=0, l=cur.length; i<l; i++)
                     recurse(cur[i], prop + "[" + i + "]")
                if (l === 0)
                    result[prop] = []
            } else {
                var isEmpty = true;
                for (var p in cur) {
                    isEmpty = false
                    recurse(cur[p], prop ? prop+" - "+p : p)
                }
                if (isEmpty && prop)
                    result[prop] = {}
            }
        }
        recurse(data, "")
        return result
    }

    isURL(str) {
        if (str === null || typeof str !== 'string') return false
        var urlRegex = '^(?!mailto:)(?:(?:http|https|ftp)://)(?:\\S+(?::\\S*)?@)?(?:(?:(?:[1-9]\\d?|1\\d\\d|2[01]\\d|22[0-3])(?:\\.(?:1?\\d{1,2}|2[0-4]\\d|25[0-5])){2}(?:\\.(?:[0-9]\\d?|1\\d\\d|2[0-4]\\d|25[0-4]))|(?:(?:[a-z\\u00a1-\\uffff0-9]+-?)*[a-z\\u00a1-\\uffff0-9]+)(?:\\.(?:[a-z\\u00a1-\\uffff0-9]+-?)*[a-z\\u00a1-\\uffff0-9]+)*(?:\\.(?:[a-z\\u00a1-\\uffff]{2,})))|localhost)(?::\\d{2,5})?(?:(/|\\?|#)[^\\s]*)?$'
        var url = new RegExp(urlRegex, 'i')
        return str.length < 2083 && url.test(str)
    }

}


// WEBPACK FOOTER //
// ./src/components/Seller/Lookup/SellerLookup.jsx